import './AppEnablerView.css';
import React, { useState } from 'react';
import { disableMachineApp, enableMachineApp, getMachineAppList } from '../models/machine_app_implementation_data';
import machine_app_implementation_manager from '../models/machine_app_implementation_manager';

export function AppEnablerView() {
  const [machineAppList, setMachineAppList] = useState(getMachineAppList());

  const handleOnChange = (uuid: string, isChecked: boolean) => {
    if (isChecked) enableMachineApp(uuid);
    else disableMachineApp(uuid);
    machine_app_implementation_manager.instance.load();
    setMachineAppList(getMachineAppList());
  };

  return <div className='machine_app_app_enabler_view'>
    <h3>Enable Applications</h3>

    <div className='machine_app_app_enabler_list'>
      {machineAppList.map(item => {
        return <div key={item.uuid} className="machine_app_app_enabler_list_item">
          <span>&#8226; {item.name}</span>
          <div>
            <input readOnly type="checkbox" onChange={ev => handleOnChange(item.uuid, !item.isAvailable)} checked={item.isAvailable} />
            <label>Is Available</label>
          </div>
        </div>;
      })}
    </div>
  </div>;
}